module.exports = __webpack_public_path__ + "img/avatar_4@2x.983f399a.png";